import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/tenant/counts/tenant.counts.query.gql"
import type {
  TenantCountsQuery,
  TenantCountsQueryVariables,
} from "@/v2-backoffice-client/tenant/counts/__types__/tenant.counts.query"

type Options = QueryHookOptions<TenantCountsQuery, TenantCountsQueryVariables>

export function useTenantCountsQuery(options?: Options) {
  return useQuery<TenantCountsQuery, TenantCountsQueryVariables>(query, options)
}
